import type { Messages } from '../types'
import { adminCommerceMessages } from './admin-commerce'
import { trailerMessages } from './trailer'

export const zhTW = {
  adminCommerce: adminCommerceMessages['zh-TW'],
  trailerRefresh: trailerMessages['zh-TW'],
  home: {
    quotaFull: '訂閱已達目前額度，可查看會員方案。',
    search: '搜尋番號、女優或標題',
    updates: '我的訂閱動態',
    updatesBody: '你追蹤的女優，作品更新都在這裡。',
    following: '我追蹤的女優',
    followingBody: '選擇一位，只看她的動態。',
    discover: '隨便看看吧',
    discoverBody: '從片庫隨機挑選一些作品，看看有沒有你喜歡的。',
    shuffle: '換一批',
    scrollPrevious: '{section}：向左滑動',
    scrollNext: '{section}：向右滑動',
    favorites: '收藏回顧',
    favoritesBody: '回到你儲存的作品 · 按發行日期排列',
    noSubscriptionsBody: '從一位喜歡的女優開始。訂閱後，她的作品會出現在這裡。',
    noUpdates: '追蹤的人暫時沒有作品動態',
    noUpdatesBody: '你的訂閱會保留，也可以先去探索更多作品。',
    noFavorites: '還沒有收藏。看到喜歡的作品，點一下愛心，下次就能在這裡找到。',
    noDiscovery: '目前沒有可展示的作品，稍後再來看看。',
  },

  admin7: {
    overviewHint: '本機業務資料；尚未檢查外部服務狀態',
    orders: '訂單查核',
    config: '必要設定',
    content: '內容維護',
    tasks: '任務管理',
    empty: '目前沒有紀錄',
    unknown: '尚未確認操作結果，請查詢原請求的處理結果，不要重新送出。',
    recover: '查詢原請求',
    receipt: '已確認的處理結果',
    newRequest: '發起另一項操作',
    requestKey: '請求鍵',
    role: '角色',
    saveRole: '確認修改角色',
    user: '一般使用者',
    admin: '管理員',
    details: '查看詳細資料',
    save: '儲存',
    readBack: '讀回目前狀態',
    loading: '讀取中…',
    email: '電子信箱',
    userId: '使用者 ID',
    id: '紀錄 ID',
    status: '狀態',
    source: '來源',
    editActressSource: '修正女優抓取來源',
    sourceIdentifier: 'JavBus 來源 ID',
    currentSource: '目前來源 ID',
    sourceHint: '儲存只會修正來源，不會開始抓取。若要更新資料，請另外選擇重新整理女優資料。',
    sourceFormat: '1–80 個英文字母、數字、底線或短橫線，第一個字元為字母或數字',
    sourceConflict: '來源已被修改，請先重新讀取目前值，再決定是否儲存。',
    reloadSource: '重新查詢來源',
    continueEditing: '繼續編輯',
    trailerMaintenance: '單影片預告維護',
    trailerHint: '僅處理所選影片。新預告成功前保留已有資產；加入佇列後按任務狀態確認，可申請取消。',
    trailerMode: '補源方式',
    trailerAuto: '自動發現',
    trailerUrl: '公開預告 URL',
    trailerFile: '本機預告檔案',
    trailerUrlHint: '支援 DMM、MGS、加勒比等已允許的公開預告路徑；其他來源請使用本機檔案。',
    trailerFileHint: 'MP4 或 MPEG-TS，最大 200 MiB；檔案內容由伺服器驗證。',
    uploading: '正在上傳並等待確認，請保留此頁；逾時後只查詢原任務。',
    all: '全部',
    amount: '金額',
    created: '建立時間',
    paid: '支付時間',
    expires: '到期時間',
    providerStatus: '服務商狀態',
    merchantOrder: '商店訂單編號',
    orderHint:
      '僅供查閱 Payment 訂單；不含獨立的 Stars 帳本，不會向服務商查詢訂單或發放權益。各幣別分開顯示。',
    revenue: '本月 CCPayment 已付（USD）',
    revenueHint: '以 UTC 月份計算，僅含 USD；不含 Stars、CDKey 或手動開通的權益',
    limit: '每日免費註冊名額',
    translationUrl: '翻譯服務地址',
    model: '翻譯模型',
    translationKey: '翻譯 API 金鑰',
    appId: 'CCPayment App ID',
    paymentKey: 'CCPayment 金鑰',
    fiat: '計價法幣 ID',
    coin: '計價幣 ID',
    configured: '已設定；留空保留',
    unset: '未設定',
    configHint: '不會顯示金鑰原值；留白即可保留。儲存後會顯示已遮蔽敏感資訊的設定，不代表外部服務已驗證。',
    recent: '抓取近期內容',
    actressCrawl: '抓取女優作品',
    videoRefresh: '重新整理影片',
    actressRefresh: '重新整理女優資料',
    translateVideo: '翻譯單片',
    translateBatch: '限量批次翻譯',
    kind: '操作',
    target: '目標內部 ID',
    pages: '最大頁數（1–10）',
    batchLimit: '批次上限（1–50）',
    enqueue: '確認加入佇列',
    taskHint: '加入佇列不表示執行完成。離開頁面不會取消任務；取消只作用於所選任務。',
    active: '進行中的任務',
    history: '歷史任務',
    cancelTask: '申請取消此任務',
    cancellation: '已要求取消，等待執行端確認最終狀態',
    progress: '處理 {processed} / {total} · 成功 {success} · 失敗 {failed}',
    attempts: '嘗試 {attempts} / {max}',
    errorCode: '錯誤碼',
    taskId: '任務 ID',
    searchActress: '搜尋本機女優',
    searchVideo: '搜尋影片番號或標題',
    searchBound: '請輸入至少 2 個字元，最多顯示 20 筆結果',
    noContent: '找不到符合的內容，請調整搜尋關鍵字',
    selectedContent: '已選擇：{name}',
    search: '查詢',
    select: '選擇',
    unavailableStar: '缺少 JavBus Star ID',
    translationTitle: '人工修正譯題',
    videoId: '影片內部 ID',
    locale: '語言',
    title: '標題',
    translationSaved: '譯題已儲存',
    viewUser: '管理權益',
    snapshot: '目前權益結束時間',
    manualHint: '預設追加到有效權益之後；已過期從目前時間起算。終身權益不可降級。',
    months: '月數（1–120）',
    expectedEnd: '預計結束時間（以伺服器確認結果為準）',
    membershipConflict: '權益快照或請求發生衝突，請重新讀取使用者狀態後再操作。',
    replaceLifetimeEffect: '替換後為終身權益，沒有到期時間。',
    replaceFiniteEffect: '替換後會從本次生效時間起算 {months} 個月，不保留目前剩餘天數，可能縮短權益期間。',
    append: '追加權益',
    replace: '替換權益',
    mode: '權益操作',
    reason: '操作備註',
    replaceConfirm: '確認以所選方案替換目前權益，可能縮短有效期',
  },
  brand: { name: 'JAV Tracker', admin: '管理後台' },
  nav: {
    today: '今日',
    discover: '發現',
    library: '片庫',
    search: '搜尋',
    me: '我的',
    searchPlaceholder: '搜尋番號、女優、標籤',
    account: '帳戶選單',
    logout: '登出',
    admin: '管理後台',
    language: '語言',
    back: '返回',
    backTo: '返回 {target}',
    skipToContent: '跳到主要內容',
  },
  common: {
    retry: '重試',
    loading: '載入中…',
    loadMore: '繼續載入',
    loadError: '載入失敗，請重試',
    networkError: '網路連線失敗',
    cancel: '取消',
    apply: '套用',
    clearAll: '清除全部',
    confirm: '確認',
    close: '關閉',
    copy: '複製',
    copied: '已複製',
    copyFailed: '複製失敗，請手動選擇複製',
    videosCount: '{count} 部',
    viewAll: '查看全部',
    upgrade: '升級',
    end: '已經到底了',
    autoPaused: '已載入 {count} 部，繼續瀏覽請手動載入',
    unknownOutcome: '請求結果未知，正在向伺服器確認…',
    unknownPending: '請求結果尚未確認，請查詢狀態後再繼續。',
    verifyState: '查詢狀態',
    mockNotice: 'Mock 資料預覽 · 所有內容均為合成示例',
  },
  video: {
    retranslate: '重新翻譯',
    retranslateHint: '重新翻譯本片標題，保留人工修訂；完成後自動更新譯文。',
    new: '新',
    magnets: '磁力 {count}',
    noMagnets: '等待磁力',
    trailer: '預告',
    solo: '獨演',
    favorite: '收藏',
    favorited: '已收藏',
    unfavorite: '取消收藏',
    copyCode: '複製番號',
    coverAlt: '{code} 封面',
    coverFallback: '封面',
    releaseDate: '發行日',
    duration: '片長',
    minutes: '{count} 分鐘',
    maker: '製作商',
    series: '系列',
    cast: '出演',
    tags: '標籤',
    translated: '譯文',
    original: '日文原文',
    playTrailer: '播放預告片',
    closeTrailer: '關閉預告',
    trailerLabel: '{code} 預告片',
    trailerError: '預告片載入或播放失敗，請重試。',
    trailerUnsupported: '目前瀏覽器不支援此預告格式，請換用支援 MediaSource 的瀏覽器。',
    trailerPlayBlocked: '瀏覽器暫停了自動播放，請使用下方播放控件。',
    trailerHint: '預告只在點擊後載入。',
    noTrailer: '目前沒有預告片',
    copyBest: '複製最佳磁力',
    bestMeta: '{size} · 做種 {seeders} · {source}',
    bestRule: '依做種數與檔案大小自動挑選',
    noMagnetYet: '目前沒有磁力，可嘗試重新整理',
    allMagnets: '全部磁力',
    magnetCount: '{count} 條',
    refreshMagnets: '重新整理磁力',
    refreshQuota: '今日剩餘 {remaining}/{limit}',
    refreshing: '正在重新整理…',
    colName: '名稱',
    colSize: '檔案大小',
    colSeeders: '做種',
    colSource: '來源',
    best: '最佳',
    notFound: '找不到這部影片',
    notFoundBody: '番號可能有誤，或者尚未入庫。可以試試線上搜尋。',
  },
  actress: {
    recrawl: '再次抓取',
    recrawlHint: '抓取並入庫近期作品，最多掃描 5 頁；完成後自動更新作品列表。',
    subscribe: '訂閱',
    subscribed: '已訂閱',
    pending: '確認中…',
    unknown: '重新確認',
    unsubscribe: '取消訂閱',
    works: '作品',
    soloOnly: '獨演',
    withCompilations: '含合集',
    pushing: '新作通知會傳送到你的 Telegram',
    pushOff: '綁定 Telegram 後可接收新作通知',
    debut: '出道',
    birthday: '生日',
    height: '身高',
    measurements: '三圍',
    videoTotal: '作品',
    limitReached: '免費版最多訂閱 5 位女優',
    notFound: '找不到這位女優',
  },
  today: {
    title: '今日新作',
    summary: '自上次訪問以來 {count} 部新作 · 訂閱 {actresses} 位女優',
    all: '全部',
    manage: '管理訂閱',
    hasMagnets: '有磁力',
    hasTrailer: '有預告',
    unfavorited: '未收藏',
    sortRelease: '按發行日',
    today: '今天',
    yesterday: '昨天',
    groupCount: '{count} 部',
    emptyNoSubs: '還沒有訂閱任何女優',
    emptyNoSubsBody: '訂閱後，她們的新作會按發行日出現在這裡。',
    goDiscover: '去發現女優',
    emptyFiltered: '目前篩選下沒有作品',
    emptyFilteredBody: '換個篩選條件，或者清除篩選看看全部動態。',
    quotaTitle: '免費版 · 訂閱女優',
    quotaFull: '已達上限，會員可無限訂閱並去除廣告',
    viewPlans: '查看會員方案',
  },
  discover: {
    title: '發現',
    videos: '影片',
    actresses: '女優',
    tags: '標籤',
    filter: '篩選',
    filterCount: '篩選 · {count}',
    filterDraft: '草稿 · 尚未套用',
    applied: '已套用：',
    onlyShow: '僅顯示',
    solo: '獨演作品',
    hasMagnets: '有磁力',
    hasTrailer: '有預告',
    favorited: '我收藏的',
    releaseWindow: '發行時間',
    anyTime: '不限',
    days30: '30 天',
    thisYear: '今年',
    tag: '標籤',
    sortLabel: '影片排序',
    sortNewest: '發行日期 · 新到舊',
    sortOldest: '發行日期 · 舊到新',
    sortCrawledNewest: '抓取日期 · 新到舊',
    sortCrawledOldest: '抓取日期 · 舊到新',
    pageAt: '正在看第 {page} 頁',
    jump: '跳轉',
    jumpLabel: '跳至指定頁面',
    actressFilter: '姓名、日文名、羅馬拼音',
    all: '全部',
    subscribedOnly: '已訂閱',
    unsubscribedOnly: '未訂閱',
    hotTags: '熱門標籤',
    hotTagsHint: '依全站收藏次數排序',
    searchTags: '搜尋全部標籤',
    expand: '展開其餘 {count}',
    collapse: '收起',
    tagFilterActive: '標籤：{name}',
  },
  tagCategory: {
    QUALITY_FORMAT: '畫質與格式',
    RELEASE_LABEL: '發行廠牌',
    BODY_PERSONA: '身材與人設',
    ROLE_COSTUME: '角色與服裝',
    RELATION_CAST: '關係與陣容',
    GENRE_SCENARIO: '題材與場景',
    PLAY_FETISH: '玩法與偏好',
    OTHER: '其他',
  },
  library: {
    title: '片庫',
    favorites: '收藏影片 · {count}',
    favoritesTab: '收藏影片',
    subscriptions: '訂閱女優 · {count}',
    favoritedAt: '{actress}',
    latest: '最新 {code}',
    quota: '免費版額度',
    emptyFavorites: '還沒有收藏的影片',
    emptyFavoritesBody: '在任何影片卡片上點愛心圖示即可收藏。',
    emptySubs: '還沒有訂閱女優',
  },
  search: {
    title: '搜尋',
    placeholder: '搜尋番號、女優、標籤',
    scopeAll: '全部',
    scopeVideos: '影片',
    scopeActresses: '女優',
    scopeTags: '標籤',
    exact: '番號精確命中',
    videos: '影片',
    actresses: '女優',
    tags: '標籤',
    open: '↵ 開啟',
    recent: '最近搜尋',
    clearRecent: '清除',
    noLocal: '本機沒找到想要的？線上搜尋 JavBus',
    onlineHint: '結果會入庫；緩存命中不扣次數',
    onlineButton: '線上搜尋「{keyword}」',
    onlineQuota: '今日剩餘 {remaining}/{limit}',
    onlineRunning: '正在線上搜尋… 已找到 {count} 部',
    onlineDone: '線上搜尋完成，找到 {count} 部',
    onlineCancel: '停止',
    onlineCancelled: '已停止接收結果；已入庫的作品不會撤銷',
    onlineExhausted: '今日線上搜尋次數已用完',
    keyboardHints: '↑↓ 選擇 · ↵ 開啟 · Esc 關閉',
    typeToSearch: '輸入至少 2 個字元',
    searching: '搜尋中…',
    noResult: '本機找不到符合的結果',
    kindCode: '番號',
    kindVideo: '影片',
    kindActress: '女優',
    kindTag: '標籤',
  },
  me: {
    defaultLanguage: '預設語言',
    defaultLanguageHint: '用於新作 Telegram 通知和詳情連結；未設定時使用繁體中文。介面語言可獨立切換。',
    defaultLanguageSaved: '預設語言已儲存',

    title: '我的',
    overview: '概覽',
    membership: '會員與支付',
    telegram: 'Telegram 通知',
    cdkey: '兌換 CDKey',
    security: '語言與安全',
    free: '免費版',
    active: '會員',
    expired: '已過期',
    lifetime: '終身會員',
    until: '有效期至 {date}',
    verifyBanner: '電子信箱尚未驗證：兌換 CDKey、購買會員和綁定 Telegram 前需要先驗證。',
    resendVerify: '重發驗證郵件',
    verifySent: '驗證郵件已加入寄送佇列，請稍後查看信箱',
    quotaSubs: '訂閱女優',
    quotaOnline: '線上搜尋 · 今日',
    quotaRefresh: '重新整理磁力 · 今日',
    perks: '會員：無限訂閱與額度、移除廣告。加密貨幣支付，確認入帳後自動開通。',
    monthly: '月度',
    yearly: '年度',
    lifetimePlan: '終身',
    perMonth: '/ 月',
    perYear: '/ 年',
    oneTime: '一次性',
    bestValue: '最划算',
    choose: '選擇{plan}',
    price: '[價格]',
    orderPaid: '支付成功，會員權益已生效。',
    orderCancelled: '訂單已關閉，未據此開通會員。',
    orderUnknown: '支付訂單仍待確認，請查詢原訂單，不要重複建立。',
    goCheckout: '前往支付',
    checkOrder: '查詢原訂單',
    tgUnknown: '操作結果尚未確認，請檢查綁定狀態；不要自動重複傳送請求。',
    tgRegenerate: '重新取得會替換舊綁定碼。',
    tgCopy: '複製綁定指令',
    tgOpenBot: '開啟機器人',
    tgCheck: '檢查綁定狀態',
    cdkeyConfirm: '確認原兌換請求',
    cdkeyUnknown: '兌換結果未知，已重新讀取會員狀態。可確認原兌換請求，不要更換兌換碼重複送出。',
    orderPending: '訂單已建立，等待支付確認。關閉頁面不會影響入帳，權益以伺服器確認為準。',
    tgBound: '已綁定 @{username}',
    tgUnbound: '未綁定',
    tgBody: '訂閱的女優推出新作時會收到通知。首次綁定可領取 7 天會員。',
    tgRewarded: '首次綁定獎勵已領取',
    tgTest: '傳送測試訊息',
    tgTestSent: '測試訊息已排隊傳送',
    tgUnbind: '解除綁定',
    tgBind: '取得綁定碼',
    tgCode: '在 Telegram 中向機器人傳送：{code}',
    cdkeyLabel: '輸入兌換碼',
    cdkeyRedeem: '兌換',
    cdkeyNeedVerify: '驗證電子信箱後可用',
    cdkeyDone: '兌換成功，會員已開通',
    cdkeyHint: 'Mock 可用兌換碼：DEMO-CDKEY-2026',
    language: '介面語言',
    changePassword: '修改密碼',
    logout: '登出',
  },
  auth: {
    login: '登入',
    register: '註冊',
    email: '電子信箱',
    password: '密碼',
    optional: '選填',
    forgot: '忘記密碼？',
    submitLogin: '登入',
    submitRegister: '建立帳號',
    demoLink: '先逛逛訪客 Demo →',
    passwordRule: '至少 8 個字元，包含英文字母和數字，最多 72 位元組（中文和表情符號會佔用多個位元組）',
    headline: '訂閱女優，\n新作第一時間送到你手裡。',
    mockHint: 'Mock 帳號：demo@example.com 或 admin@example.com，密碼 password1',
    terms: '服務條款',
    privacy: '隱私政策',
    forgotTitle: '忘記密碼',
    forgotBody:
      '請輸入註冊的電子信箱。已綁定 Telegram 的帳號會優先透過 Telegram 收到重設連結，其他帳號則以電子郵件寄送。',
    forgotSubmit: '傳送重設連結',
    forgotDoneTitle: '請求已送出',
    forgotDone: '如帳號符合條件，系統會安排傳送重設連結。此提示不代表已送達；可在 {seconds} 秒後重新申請。',
    forgotResend: '重新傳送',
    forgotPrivacy: '所有電子信箱都會收到相同提示，不會透露帳號是否存在。',
    backToLogin: '返回登入',
    forgotHeadline: '忘了密碼也沒關係，\n你追的人還在。',
    resetTitle: '設定新密碼',
    resetBody: '完成後，所有裝置都會登出。',
    newPassword: '新密碼',
    confirmPassword: '再輸入一次',
    show: '顯示',
    hide: '隱藏',
    ruleLength: '至少 8 個字元（表情符號等可能計為兩個字元）',
    ruleBytes: '最多 72 位元組（中文和表情符號會佔用多個位元組）',
    ruleMix: '包含字母和數字',
    ruleMatch: '兩次輸入一致',
    resetSubmit: '儲存新密碼',
    resetExpired: '連結已過期或已使用？',
    resetAgain: '重新申請 →',
    resetDone: '密碼已更新，請重新登入',
    resetHeadline: '換一把新鑰匙，\n其他裝置會自動登出。',
    verifyingTitle: '正在驗證電子信箱…',
    verifiedTitle: '電子信箱已驗證',
    verifiedBody: '現在可以兌換 CDKey、購買會員，並綁定 Telegram 接收新作通知。',
    goBindTelegram: '去綁定 Telegram',
    backToday: '回到今日',
    verifyFailedTitle: '電子信箱驗證未完成',
    verifyFailedBody: '請查看錯誤提示；連結失效時可登入後重新申請驗證郵件。',
    registerEmailFailed: '帳號已建立，驗證郵件暫未確認排隊；可在帳戶頁重新申請。',
    alreadyVerified: '電子信箱已驗證',
    currentPassword: '目前密碼',
    logoutAll: '登出所有網頁工作階段',
    logoutAllDone: '網頁工作階段已登出，請重新登入',
    resendVerify: '重新傳送驗證郵件',
    goLogin: '去登入',
  },
  jobs: {
    nextPage: '線上搜尋下一頁',
    cancelling: '已請求取消，等待確認',
    confirmRequest: '確認原請求',
    resume: '重新連線任務',
    unknown: '送出結果尚未確認。確認原請求會使用同一個請求編號，不會重複建立已存在的任務。',
    disconnected: '任務仍可能繼續執行，連線中斷不會取消任務。可重新連線查看狀態。',
    partial: '已取得部分可用結果；額度按可用結果結算。',
  },
  onboarding: {
    step1: '選女優',
    step2: '收藏影片',
    step3: '綁定 Telegram',
    step4: '完成',
    progress: '{current} / 1 · {label}',
    skip: '略過導覽',
    title: '先選幾位你想追的女優',
    body: '建議 3 位，最多 5 位。她們的新作會出現在「今日」，也可以透過 Telegram 接收通知。',
    selected: '已選 {count} / 5',
    continue: '訂閱 {count} 位並繼續',
    needOne: '至少選 1 位',
  },
  landing: {
    navigation: '首頁導覽',
    eyebrow: '你的私人追更清單',
    signupFree: '建立免費帳號',
    heroA: '追蹤你喜歡的，',
    heroB: '新作不再錯過。',
    heroBody: '把追蹤的女優、想留住的作品和新作動態放在一起。開啟 JAV Tracker，先看與你有關的更新。',
    seePreview: '看看如何追更',
    loginHint: '登入後瀏覽作品、管理訂閱與收藏。註冊名額以註冊頁為準。',
    previewTitle: '我的訂閱動態',
    example: '追更示例',
    sampleOne: '追蹤女優的新作，整理在一起',
    sampleTwo: '值得留意的作品，隨手收藏',
    sampleAvailable: '磁力已收錄',
    previewNote: '綁定 Telegram，也可以接收新作通知。',
    exampleNote: '以上為功能示意，番號與內容均為合成示例，並非即時更新。',
    how: '如何使用',
    howTitle: '從追蹤開始，讓追更成為日常。',
    f1Title: '找到想追蹤的人',
    f1Body: '搜尋女優名字、番號或標題，查看作品與女優資料。',
    f2Title: '訂閱，建立自己的動態',
    f2Body: '追蹤的女優集中管理，作品按發行日期整理；喜歡的影片可以單獨收藏。',
    f3Title: '回來看看，或接收通知',
    f3Body: '在首頁查看訂閱動態。主動綁定 Telegram 後，也可以在那裡接收新作通知。',
    pricingTitle: '免費開始，按需選擇會員',
    pricingBody:
      '免費帳號可瀏覽作品、收藏影片和訂閱女優。訂閱及線上操作有額度限制，目前可用額度會在登入後顯示。',
    membershipBody: '需要更多額度時，再查看會員方案。實際權益、價格與購買可用狀態以帳號內顯示的資訊為準。',
    viewMembership: '登入查看會員方案',
    startTitle: '先追蹤一位喜歡的女優。',
    startBody: '讓下一次開啟首頁，有值得期待的內容。',
    sessionError: '暫時無法確認登入狀態，你仍可閱讀首頁。',
    termsTitle: '服務說明',
    termsBody:
      'JAV Tracker 是面向成年人的資料管理與新作追蹤工具。第三方作品資訊可能延遲或失效，請在所在地允許的範圍內使用。',
    termsContact: '索取完整服務條款 ↗',
    privacyTitle: '隱私說明',
    privacyBody:
      '登入透過 Cookie 維持工作階段；訂閱和收藏會連結至你的帳號。你可以自行綁定 Telegram，也能在帳號設定解除綁定。此處僅說明功能，完整政策及資料相關要求請洽客服。',
    privacyContact: '隱私政策與資料諮詢 ↗',
    rights: '© JAV Tracker',
  },
  admin: {
    overview: '儀錶盤',
    users: '使用者',
    crawler: '爬蟲控制台',
    groupOverview: '概覽',
    groupUsers: '使用者與收入',
    groupContent: '內容',
    groupCrawl: '採集',
    groupSystem: '系統',
    revenue: '收入',
    cdkeys: 'CDKey',
    videos: '影片',
    aliases: '女優別名',
    translations: '翻譯任務',
    crawlerLogs: '爬蟲日誌',
    config: '系統設定',
    monitor: '監控',
    notInScope: '首版暫未開放',
    backToApp: '← 返回前台',
    refresh: '重新整理',
    telegramTest: '傳送 Telegram 測試',
    statVideos: '影片',
    statActresses: '女優',
    statUsers: '使用者',
    statRevenue: '本月收入',
    statTranslations: '待翻譯',
    statQueue: '後台佇列失敗',
    delta24h: '+{count} 近 24 小時',
    delta7d: '+{count} 近 7 天',
    activeMembers: '有效會員 {count}',
    sinceMonth: '北京時間月初起',
    ingest: '入庫新作 · 近 14 天',
    sample: 'Mock 資料',
    deps: '外部依賴',
    recentJobs: '最近後台任務',
    usersSub: '{count} 位使用者 · 管理員不受電子信箱驗證限制',
    searchEmail: '搜尋電子信箱',
    filterAll: '全部',
    filterActive: '有效會員',
    filterFree: '免費',
    filterExpired: '已過期',
    filterAdmin: '管理員',
    colEmail: '電子信箱',
    colRole: '角色',
    colMembership: '會員',
    colTelegram: 'Telegram',
    colSubs: '訂閱',
    colCreated: '註冊',
    roleAdmin: '管理員',
    roleUser: '一般使用者',
    bound: '已綁定',
    unbound: '未綁定',
    activate: '啟用會員',
    activateTitle: '手動啟用會員',
    current: '目前：{status}',
    activateFooter: '按套餐標價計入收入，並寫入審計。',
    activateConfirm: '確認啟用',
    activateDone: '已啟用 {email}',
    pageOf: '第 {page} 頁',
    prev: '上一頁',
    next: '下一頁',
    crawlerSub: '內置調度每 3 小時加入佇列 · 僅 normal 分類',
    startIncremental: '啟動全站增量',
    jobTitle: '作品抓取 · normal',
    running: '執行中',
    finished: '本輪完成',
    stop: '請求停止',
    slice: '本輪處理區段 · 影片 {processed} / {total}',
    sliceMeta: '頁 {pages} / {pageLimit} · {elapsed}s / {budget}s',
    okCount: '本輪成功',
    failCount: '失敗',
    failHint: '將在下一個處理區段重試',
    notifyCount: '新作通知',
    notifyHint: '已寫入通知佇列',
    slots: '全域並行工作數',
    slotsHint: '由所有執行個體共用',
    crawlActress: '抓取單個女優',
    starLabel: 'JavBus 女優 ID 或名字',
    enqueue: '加加入佇列列',
    enqueueDone: '已加加入佇列列：{jobId}',
    enqueueHint: '同一女優已有任務時直接返回現有任務，不重複建立。',
    liveLogs: '即時日誌',
    liveHint: '每 5 秒重新整理',
    forbidden: '需要管理員權限',
  },
  membership: {
    FREE: '免費',
    ACTIVE: '有效',
    EXPIRED: '已過期',
    MONTHLY: '月度',
    YEARLY: '年度',
    LIFETIME: '終身',
  },
} satisfies Messages
